import React from 'react'
import styled from 'styled-components'
import { purpleButtonStyle } from './styled'
import { Link } from 'gatsby'

const Button = styled(Link)`
  ${purpleButtonStyle};
  display: inline-block;
  text-align: center;
`

const GetStartedButton = ({ className }) => (
  <Button className={className} to="/sellwithflip">
    Get Started
  </Button>
)

export default GetStartedButton
